<template>
  <section :class="backgroundClasses">
    <h2 v-if="content.title" class="uppercase font-title text-pink mb-8 pt-8" v-reveal>
      {{ content.title }}
    </h2>
    <ul class="flex flex-col gap-10">
      <template v-for="(link, linkIndex) in content.items" :key="link.flexKey">
        <LinkCard
          :content="link"
          v-reveal="{ delay: 250 + linkIndex * 50 }"
          :x="x"
          :y="y"
          @update:hover-coordinates="updateHoverCoordinates"
        />
      </template>
    </ul>
  </section>
</template>

<script lang="ts">
import { type PropType, toRef } from 'vue'

import LinkCard from '@/components/cards/LinkCard.vue'
import { useBackgroundColor } from '@/composables/useBackgroundColor.ts'

export default {
  name: 'LinksSection',
  components: { LinkCard },
  props: {
    content: {
      type: Object as PropType<LinksSection>,
      required: true,
    },
  },
  setup(props) {
    return {
      backgroundClasses: useBackgroundColor(toRef(props.content, 'background')),
    }
  },
  data() {
    return {
      x: 0,
      y: 0,
    }
  },
  methods: {
    updateHoverCoordinates({ x, y }: { x: number; y: number }) {
      this.x = x
      this.y = y
    },
  },
}
</script>
